import {signOut} from "next-auth/react"
import Error404 from "@/pages/404";
import Error500 from "@/pages/500";
import Error429 from "@/pages/429";
import Error403 from "@/pages/errorpages/403";
import { REDIRECT, Url } from "@/imports-files/pages/admins/logout";
import { Loading } from "@/components/loading";

export class ErrorPages
{
  setErrorCode(data)
  {
    var errorCode = data?.response?.status == undefined ? false : data.response.status;
    errorCode     = data.code == 'ECONNREFUSED' ? 500 : errorCode;
    return errorCode;
  }

  setData(data)
  {
    data =  data.code == 'ECONNREFUSED' ? {} : data;
    return data;
  }

  handleErrorCodes(status_code)
  {
     let handleCodes = [401, 403, 404, 500];
     return handleCodes.includes(status_code);
  }

  handleMultipleApiErrorCodes(args)
  {
    let handleCodes = [401, 403, 404, 500];
    for(let index = 0; index < args.length; index++)
    {
        if(handleCodes.includes(args[index].status))
        {
            return args[index];
        }
    }
    
    return args[0];
  }

  renderPage(status_code, router) 
  {
    
    let user_url = '';
    if( router.pathname.includes('/admins/dashboard/') )
    {
      user_url = process.env.NEXT_PUBLIC_BASE_URL + REDIRECT.admins.login;
    }
    else if(router.pathname.includes('/agency/dashboard/'))
      {
        user_url = process.env.NEXT_PUBLIC_BASE_URL + REDIRECT.agency.login;
      }
    else
    { 
      user_url = process.env.NEXT_PUBLIC_BASE_URL
    }
    switch (status_code) {
      case 401:  localStorage.removeItem('jobFiltersData');
                 localStorage.removeItem('dataTableFiltersData');
                 localStorage.removeItem('navbarStatus');
                 let callBackUrl =  user_url;
                 signOut({ callbackUrl: callBackUrl});  
                return <>{null}</>;
      case 403:
        return <Error403/>;
      case 404:
        return <Error404 />
      case 429:
        return <Error429 />;
      case 500:
        return <Error500 />;
      default:
        return '';
    }
  }

}
